import "jquery";
import "popper.js";
import "bootstrap";

import "bootstrap/dist/css/bootstrap.css";

import "./common/three-extensions";

import {
    startLocal, startCombo, selectByGuid, selectByDbId, isolateByGuid, isolateByDbId, setViewCube,
    addSelectionListener, removeSelectionListener, addSdModelLoadedListener, removeSdModelLoadedListener, getSdApi
} from "./viewer";
import { startUploader } from "./upload/upload";
import { startPending } from "./pending";
import { startProject } from "./project/project";
import { startInfo } from "./info/info";
import * as SmartDrawings from "./smartDrawings";
import { Misc } from "./common/misc";
import ClientConfig = SmartDrawings.ClientConfig;

/**
 * The main entry point of the SmartDrawings application.
 */

async function startLocalViewer(model: SmartDrawings.ViewModel, baseUrl: string = null,
    sandboxToken: string = null, queryParameters: string = null) {
    if (!Misc.alertIe()) {
        await startLocal(model, baseUrl, sandboxToken, queryParameters);
    }
}

function startComboViewer(model: SmartDrawings.ComboViewModel) {
    if (!Misc.alertIe()) {
        startCombo(model);
    }
}

function startUpload(project, modelSettingsIds, fileExtensions, clientConfig: ClientConfig = null) {
    let uploadChunkSize = 5;
    if (clientConfig !== null)
        uploadChunkSize = clientConfig.uploadChunkSize;

    if (!Misc.alertIe()) {
        startUploader(project, modelSettingsIds, fileExtensions, uploadChunkSize);
    }
}

function startPendingView(guid: string) {
    if (!Misc.alertIe()) {
        startPending(guid);
    }
}

function startProjectView(model, modelSettingsIds) {
    if (!Misc.alertIe()) {
        startProject(model, modelSettingsIds);
    } 
}

function startInfoView() {
    if (!Misc.alertIe()) {
        startInfo();
    }
}

export {
    startLocalViewer,
    startComboViewer,
    startUpload,
    startPendingView,
    startProjectView,
    startInfoView,
    selectByGuid,
    selectByDbId,
    isolateByGuid,
    isolateByDbId,
    setViewCube,
    addSelectionListener,
    removeSelectionListener,
    addSdModelLoadedListener,
    removeSdModelLoadedListener,
    getSdApi
}